const a = (o) => !!o && !!o.shadowRoot && !!o.attachShadow;
export {
  a as hasShadowDom
};
